import { Component } from '@angular/core';
import { UntypedFormControl, Validators, FormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../service/http.service';
import { CommonModule } from '@angular/common';
import { CountryISO, NgxIntlTelInputModule, SearchCountryField } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-advisor-registration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxIntlTelInputModule],
  templateUrl: './advisor-registration.component.html',
  styleUrl: './advisor-registration.component.scss'
})
export class AdvisorRegistrationComponent {

  status: any;
  expetiseList: any = [];
  knownLanguage: any = [];
  searchExpertise: any;
  selectedExertise: any = [];
  selectedLanguage: any = [];


  astrologerRegForm: FormGroup;
  constructor(
    private _homeService: HttpService,
    private toastr: ToastrService,
    private formBuilder: UntypedFormBuilder
  ) {
    this.astrologerRegForm = this.formBuilder.group({
      astrologerName: new UntypedFormControl(null, Validators.required),
      emailAddress: new UntypedFormControl(null, [
        Validators.required,
        Validators.email
      ]),
      mobileNumber: new UntypedFormControl(null, Validators.required),
      alternateMobileNumber: new UntypedFormControl(null),
      aboutMe: new UntypedFormControl(null, Validators.required),
      workExperince: new UntypedFormControl(null, Validators.required),
      expertiseArea: null,
      profilePic: null,
      knownLanguage: null,
      gender: new UntypedFormControl("MALE", Validators.required),

    });

  }

  ngOnInit(): void {
    this.getAllExpertiseList();
  }

  onSubmit(): void {

    this.astrologerRegForm.markAllAsTouched();

    if (this.astrologerRegForm.invalid) {
      return;
    }

    if (this.selectedExertise.length < 1) {
      this.toastr.error("Please select expertise area.", 'Oops', { timeOut: 3000 });
      return
    }

    if (this.selectedLanguage.length < 1) {
      this.toastr.error("Please select known language", 'Oops', { timeOut: 3000 });
      return
    }

    this.astrologerRegForm.value.expertiseArea = this.selectedExertise.toString();
    this.astrologerRegForm.value.knownLanguage = this.selectedLanguage.toString();

    if (this.astrologerRegForm.valid) {
      this._homeService.astrologerRegister(this.astrologerRegForm.value).subscribe((data) => {
        this.status = data;
        this.status = this.status;
        if (this.status.status == "success") {
          this.astrologerRegForm.reset();
          this.toastr.success('Once admin approves your profile, you will get a notification for interview on your email id. It usually takes upto 5 working days.', 'Your basic details are submitted.', { timeOut: 10000 });
        } else {
          this.toastr.error("Something went wrong, please try again", 'Oops', { timeOut: 3000 });
        }
      }, (error) => {
        this.toastr.error("Something went wrong, please try again", 'Oops', { timeOut: 3000 });
      });
    }
  }

  selectExpertise(item: any) {
    if (this.selectedExertise.length > 2) {
      this.toastr.error("You can select upto 3.", 'Oops', { timeOut: 3000 });
    } else {

      if (this.selectedExertise.length > 0) {
        let checkExist = false;
        this.selectedExertise.forEach((data: any) => {
          if (data == item) {
            checkExist = true;
            return;
          }
        });

        if (!checkExist) {
          this.selectedExertise.push(item);
        }
      } else {
        this.selectedExertise.push(item);
      }
    }

    console.log(item, this.selectedExertise);
  }

  deleteExpertise(item: any, index: any) {
    this.selectedExertise.forEach((data: any) => {
      if (data == item) {
        this.selectedExertise.splice(index, 1);
        return;
      }
    });
  }

  selectKnownLanguage(item: any) {
    if (this.selectedLanguage.length > 0) {
      let checkExist = false;
      this.selectedLanguage.forEach((data: any) => {
        if (data == item) {
          checkExist = true;
          return;
        }
      });

      if (!checkExist) {
        this.selectedLanguage.push(item);
      }
    } else {
      this.selectedLanguage.push(item);
    }
    console.log(item, this.selectedLanguage);
  }

  deleteSelectedLanguage(item: any, index: any) {
    this.selectedLanguage.forEach((data: any) => {
      if (data == item) {
        this.selectedLanguage.splice(index, 1);
        return;
      }
    });
  }

  getAllExpertiseList() {
    this._homeService.getAllExpertiseList().subscribe((data) => {
      this.knownLanguage = data?.data?.knownLanguage;
      this.expetiseList = data?.data?.expertiseArea;
      console.log(this.expetiseList, "exp");

    }, (error) => {
      console.log(error);
    });
  }

  imagePreview: string | null = null;
  showPreview = false;

  // onFileChange(event: any): void {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   if (!file.type.startsWith('image/')) {
  //     this.toastr.error('Only image files allowed');
  //     return;
  //   }
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.imagePreview = reader.result as string;
  //     this.astrologerRegForm.patchValue({
  //       profilePic: this.imagePreview
  //     });
  //   };
  //   reader.readAsDataURL(file);
  //   event.target.value = '';
  // }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      this.toastr.error('Only image files allowed');
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.imagePreview = reader.result as string;
    };
    reader.readAsDataURL(file);
    const formData = new FormData();
    formData.append('image', file);
    formData.append('extension', file.name.split('.').pop() || '');
    this._homeService.imageUpload(formData).subscribe(
      (res: any) => {
        if (res?.status === 'success') {
          this.astrologerRegForm.patchValue({
            profilePic: res.data.file_url
          });
        } else {
          this.toastr.error('Something went wrong, please try again');
        }
      },
      (error) => {
        console.error(error);
        this.toastr.error('Something went wrong, please try again');
      }
    );

    event.target.value = '';
  }


  openPreview(): void {
    this.showPreview = true;
  }

  closePreview(): void {
    this.showPreview = false;
  }

  deleteProfile(fileInput: HTMLInputElement): void {
    this.imagePreview = null;
    this.showPreview = false;
    this.astrologerRegForm.patchValue({
      profilePic: null
    });
    fileInput.value = '';
  }



  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;

}
